<template>
  <b-table striped hover :fields="fields" :items="domainsFormatted">
    <template #cell(action)="row">
      <DeleteDomainIcon
        class="float-right"
        :domain="row.item.domain"
      ></DeleteDomainIcon>
    </template>
  </b-table>
</template>

<script>
import DeleteDomainIcon from '@/xvisor/components/policyCenter/domain/DeleteDomainIcon.vue';
import DomainEventBus from '@/xvisor/bus/DomainEventBus';

export default {
  components: {
    DeleteDomainIcon,
  },
  data() {
    return {
      domainListUrl: '/policysettings/unauthorizedDomain/list.json',
      domains: [],
      fields: [
        { key: 'domain', label: 'Domain' },
        { key: 'action', label: '' },
      ],
    };
  },
  mounted() {
    DomainEventBus.$on('changed', this.httpGet);
    this.httpGet();
  },
  methods: {
    httpGet() {
      this.$http
        .get(this.domainListUrl)
        .then((response) => {
          this.domains = response.data;
        });
    },
  },
  computed: {
    domainsFormatted() {
      const formatted = this.domains.map((domain) => ({ domain }));
      return formatted;
    },
  },
};
</script>
